import { cn } from '@skupreme/shared/ui';
import { MarketplaceAvatar } from '@features/orders';
import { channelLabel, channelMarketplaceType } from '../../lib/v2';

/*
 * M2: several marks are dark on a transparent ground (Amazon's "a", BigCommerce, TikTok, eBay's dark letters, Mirakl,
 * Simon), so in the dark theme a tile that shows a logo gets the light fg colour, as the light theme's white tile does.
 * A tile showing an initial keeps the surface, since its text is drawn in fg.
 */
export const DARK_LOGO_TILE = 'sk:[[data-theme=dark]_&>span:has(>img)]:bg-fg';

/** A channel's logo, as the legacy catalog draws a marketplace: the shared avatar, its initial when it has no logo. */
export function ChannelMark({
  channel,
}: {
  channel: { provider: string | null; display_name: string | null };
}) {
  return (
    <MarketplaceAvatar
      marketplace={{ type: channelMarketplaceType(channel.provider ?? '') }}
      fallbackText={channelLabel(channel)}
      className={cn('sk:rounded-lg', DARK_LOGO_TILE)}
    />
  );
}
